import { render, staticRenderFns } from "./ModalCommentsService.vue?vue&type=template&id=3d94a7a2"
import script from "./ModalCommentsService.vue?vue&type=script&lang=js"
export * from "./ModalCommentsService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports